import { render } from "./SetAccounts.vue?vue&type=template&id=2408355d&scoped=true"
import script from "./SetAccounts.vue?vue&type=script&lang=js"
export * from "./SetAccounts.vue?vue&type=script&lang=js"

import "./SetAccounts.vue?vue&type=style&index=0&id=2408355d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2408355d"]])

export default __exports__